export const showToast = (snackbar, message, key, variant, closeSnackbar) => {
    snackbar(message, { variant: variant, persist: true, preventDuplicate: true, key:key});
    setTimeout(() => {closeSnackbar(key)}, 4000);
  }